export default "__VITE_ASSET__BsjY0OQZ__";